import { memo, useCallback, useState } from "react";
import { NotificationLogSearchFormValues } from "services/api/notifications/types";
import {
  initialNotificationLogSearchForm,
  CHANNEL_FILTER_OPTIONS,
  LOG_STATUS_FILTER_OPTIONS,
} from "services/api/notifications/consts";
import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import VehicleDropdown from "ui/components/Dropdown/VehicleDropdown/VehicleDropdown";
import { NotificationLogFilterProps } from "./types";

const NotificationLogFilters: React.FC<NotificationLogFilterProps> = ({ onSearchChange }) => {
  const [formValues, setFormValues] = useState<NotificationLogSearchFormValues>(
    initialNotificationLogSearchForm
  );

  const applyChange = useCallback(
    (updatedFormValues: NotificationLogSearchFormValues) => {
      setFormValues(updatedFormValues);
      onSearchChange(updatedFormValues);
    },
    [onSearchChange]
  );

  const handleDropdownChange = useCallback(
    (_e: any, name: string, item: DropdownOption) => {
      applyChange({ ...formValues, [name]: item.value || null });
    },
    [applyChange, formValues]
  );

  const handleResetFormClick = useCallback(
    () => applyChange(initialNotificationLogSearchForm),
    [applyChange]
  );

  return (
    <div className="flex flex-wrap gap-3 items-center py-3">
      <div className="min-w-[280px]">
        {/* Zapisnik je pregled, ne unos — unos novog vozila ovdje nema smisla. */}
        <VehicleDropdown
          name="vehicleId"
          placeholder="Odaberite vozilo"
          value={formValues.vehicleId ?? ""}
          onChange={handleDropdownChange}
          showAddNew={false}
          width="medium"
          cssClassName="bg-white"
        />
      </div>

      <div className="min-w-[160px]">
        <Dropdown
          name="channel"
          placeholder="Odaberite kanal"
          options={CHANNEL_FILTER_OPTIONS}
          onChange={handleDropdownChange}
          value={formValues.channel ?? ""}
          width="small"
          cssClassName="bg-white"
        />
      </div>

      <div className="min-w-[160px]">
        <Dropdown
          name="isSuccess"
          placeholder="Odaberite status"
          options={LOG_STATUS_FILTER_OPTIONS}
          onChange={handleDropdownChange}
          value={formValues.isSuccess ?? ""}
          width="small"
          cssClassName="bg-white"
        />
      </div>

      <div className="flex items-center">
        <span
          onClick={handleResetFormClick}
          className="text-xs font-bold cursor-pointer text-gray-700"
        >
          RESET
        </span>
      </div>
    </div>
  );
};

export default memo(NotificationLogFilters);
